import { FiCheck, FiX } from 'react-icons/fi'

import { Button } from '~/components/Buttons'
import CreativeZoom from '~/components/CreativeZoom'
import { formatDimensions } from '~/helpers'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import CardHeader from '../CardHeader'
import RejectForm from '../RejectForm'

import * as S from './styles'

const ReviewMediaCard = ({
  item,
  isRejecting,
  hasMultipleItems,
  currentIndex,
  total,
  canReview,
  approvePending,
  rejectPending,
  onClose,
  onApprove,
  onReject,
  onCancelReject,
  onSubmitReject
}: ReviewMediaCardProps) => {
  const { t } = useAPPTranslation()
  const alt = formatDimensions(item.media_size || item.settings?.ad_size)
  const mediaUrl = item.settings.media_url

  return (
    <>
      <CardHeader
        item={item}
        hasMultipleItems={hasMultipleItems}
        currentIndex={currentIndex}
        total={total}
        onClose={onClose}
      />

      <S.ScrollArea data-testid="review-media-modal-scroll-area">
        <S.Stage $rejecting={isRejecting}>
          {mediaUrl ? (
            <S.ImagePanel data-testid="review-media-modal-image-panel">
              <CreativeZoom src={mediaUrl} alt={alt} resetKey={isRejecting} />
              <S.OpenInNewTab href={mediaUrl} />
            </S.ImagePanel>
          ) : null}
          {isRejecting && (
            <RejectForm
              isPending={rejectPending}
              onCancel={onCancelReject}
              onSubmit={onSubmitReject}
            />
          )}
        </S.Stage>
      </S.ScrollArea>

      {canReview && !isRejecting && (
        <S.Footer data-testid="review-media-modal-footer">
          <Button
            data-testid="review-media-modal-reject-button"
            template="critical"
            onClick={onReject}
            text={t('rm:button.Reject')}
            iconLeft={<FiX />}
          />
          <Button
            data-testid="review-media-modal-approve-button"
            template="primary"
            onClick={onApprove}
            loading={approvePending}
            text={t('rm:button.Approve')}
            iconLeft={<FiCheck />}
          />
        </S.Footer>
      )}
    </>
  )
}

export default ReviewMediaCard
